import { type Component } from "solid-js";
import { HelpCircle } from "lucide-solid";

const Help: Component = () => {
  return (
    <div class="mx-auto max-w-3xl px-5 py-8">
      <div class="mb-6 flex items-center gap-3">
        <HelpCircle size={22} class="text-primary" />
        <h1 class="m-0 text-xl font-semibold">Yardim</h1>
      </div>
      <div class="rounded-xl border border-border bg-card p-6 text-muted-foreground">
        <p class="m-0">Yardim ve dokumantasyon yakinda burada olacak.</p>
      </div>
    </div>
  );
};

export default Help;
